import { getVersionDetail, getProductList } from '../api/version'

interface VersionConfig {
  pollingTime?: number
  immediate?: boolean
  enable?: boolean
  onVersionUpdate?: (data: any) => void
  onRefresh?: (data: any) => void
  onCancel?: (data: any) => void
}

interface VersionOptions {
  title?: string
  description?: string
  primaryColor?: string
  rocketColor?: string
  buttonText?: string
  cancelButtonText?: string
  imageUrl?: string
}

let checkTimer: NodeJS.Timeout | null = null

// 检查版本更新
export function checkVersion(config: VersionConfig, options?: VersionOptions) {
  // 新增产品列表查询
  getProductList({
    pageNum: '1',
    pageSize: '10',
    productName: '子弹发薪',
    platform: 'pc',
    status: 0
  }).then(res => {
    console.log("打印检测版本",res);

    if (res.list && res.list?.[0]?.id) {
      const product = res.list[0]


      getVersionDetail({
        versionCode: `V${require('../../package.json').version}`,
        productManagementId: product.id,
        productType: product.productType
      }).then(versionResponse => {
        console.log("获取版本详情:", versionResponse);

        const productConfig = {
          ...config,
          productManagementId: product.id,
          productType: product.productType
        }

        console.log("完整配置参数:", productConfig);
        startVersionCheck(productConfig, options)

      }).catch(versionError => {
        console.error('获取版本详情失败:', versionError)

        const productConfig = {
          ...config,
          productManagementId: product.id,
          productType: product.productType
        }
        startVersionCheck(productConfig, options)
      })
    }
  }).catch(error => {
    console.error('产品查询失败:', error)
  })
}

function startVersionCheck(config:VersionConfig & {productManagementId:number,productType:string} , options?: VersionOptions) {
  const {
    productManagementId,
    productType,
    pollingTime = 60000,
    immediate = false,
    enable = true,
    onVersionUpdate,
    onRefresh,
    onCancel
  } = config


  if (!enable) {
    return
  }



  async function checkVersionUpdate() {
    try {
      console.log(' 开始版本检测...')

      // 使用当前包版本作为参数获取版本详情
      const currentPackageVersion = `V${require('../../package.json').version}`
    // 测试用
    // const currentPackageVersion ='V1.0.1'
      console.log(' 当前包版本:', currentPackageVersion)

      const response = await getVersionDetail({
        versionCode: currentPackageVersion,
        productManagementId,
        productType
      })

      console.log('[getVersionDetail 响应]', {
        requestParams: { versionCode: currentPackageVersion, productManagementId, productType },
        fullResponse: response
      })

      const versionData = response

      if (!versionData.versionCode) {
        console.warn(' API响应中没有versionCode字段，跳过版本检测')
        return
      }

      console.log(' 获取到的版本详情:', {
        服务器版本: versionData.versionCode,
        版本描述: versionData.versionDesc,
        创建时间: versionData.createTime
      })

      // 检查是否已标记该版本为已读
      const confirmedKey = `${versionData.versionCode}_confirmed`
      const isConfirmed = localStorage.getItem('versionPrompt') === confirmedKey
      const isIgnored = localStorage.getItem('ignored-version') === versionData.versionCode

      console.log(' 版本状态检查:', {
        服务器版本: versionData.versionCode,
        是否已确认: isConfirmed,
        是否已忽略: isIgnored,
        确认键: confirmedKey
      })

      // 如果版本未被确认且未被忽略，则显示弹窗
      if (!isConfirmed && !isIgnored) {
        console.log(' 需要显示版本更新弹窗')

        const updateData = {
          newVersion: versionData.versionCode,
          currentVersion: currentPackageVersion,
          versionCode: versionData.versionCode,
          versionDesc: versionData.versionDesc,
          updateContent: versionData.versionDesc ? [versionData.versionDesc] : [],
          isForceUpdate: false,
          downloadUrl: '',
          createTime: versionData.createTime,
          external: {
            update: versionData.versionDesc ? [versionData.versionDesc] : [],
            content: versionData.versionDesc
          }
        }

        // 显示版本更新弹窗
        showVersionDialog(updateData, options, (data) => {
          // 用户点击"知道了"后标记该版本为已确认
          console.log(' 用户确认版本更新，标记为已读:', confirmedKey)
          localStorage.setItem('versionPrompt', confirmedKey)
          if (onRefresh) onRefresh(data)
        }, (data) => {
          // 用户点击"忽略此版本"
          console.log(' 用户忽略此版本:', versionData.versionCode)
          localStorage.setItem('ignored-version', versionData.versionCode)
          if (onCancel) onCancel(data)
        })

        if (onVersionUpdate) {
          onVersionUpdate(updateData)
        }
      } else {
        console.log(' 版本已处理，跳过显示')
      }
    } catch (error) {
      console.error('版本检测失败:', {
        errorDetails: error,
        requestParams: { versionCode: `V${require('../../package.json').version}`, productManagementId, productType }
      })
    }
  }

  // 立即检测
  if (immediate) {
    checkVersionUpdate()
  }

  // 定时检测
  checkTimer = setInterval(checkVersionUpdate, pollingTime)
}

// 停止版本检测
export function unCheckVersion(options: { closeDialog?: boolean; closeTimer?: boolean } = {}) {
  const { closeDialog = false, closeTimer = true } = options

  if (closeTimer && checkTimer) {
    clearInterval(checkTimer)
    checkTimer = null
  }

  if (closeDialog) {
    // 关闭版本更新弹窗
    const event = new CustomEvent('closeVersionDialog')
    window.dispatchEvent(event)
  }
}

// 显示版本更新弹窗
function showVersionDialog(data: any, options?: VersionOptions, onRefresh?: Function, onCancel?: Function) {
  console.log(' showVersionDialog被调用，准备派发事件', {
    versionCode: data.versionCode,
    versionDesc: data.versionDesc,
    hasOnRefresh: !!onRefresh,
    hasOnCancel: !!onCancel
  })

  const event = new CustomEvent('showVersionDialog', {
    detail: {
      data: {
      ...data,
      versionDesc: data.versionDesc || '默认版本描述'
    }, options, onRefresh, onCancel }
  })

  console.log(' 派发showVersionDialog事件', {
    eventType: event.type,
    versionCode: event.detail.data.versionCode,
    hasData: !!event.detail.data
  })
  window.dispatchEvent(event)
}

